export default __webpack_public_path__ + "static/media/close.8cd67cff.svg";